import AxiosService from '../../../gateway/rest/AxiosService'

class TestdataSoapRestService {
  soapPolicyEndpoint = '/testdata/soap/policies'
  soapTokenizerConfigEndpoint = this.soapPolicyEndpoint + '/tokenizerconfigs'
  soapAppsEndpoint = '/testdata/soap/apps'

  getAllWebServicePolicies(): Promise<any> {
    return AxiosService.get(this.soapPolicyEndpoint)
  }

  createWebServicePolicy(policy: any): Promise<any> {
    return AxiosService.post(this.soapPolicyEndpoint, policy)
  }

  getById(id: number): Promise<any> {
    return AxiosService.get(`${this.soapPolicyEndpoint}/${id}`)
  }

  deleteWebServicePolicy(id: number): Promise<any> {
    return AxiosService.delete(`${this.soapPolicyEndpoint}/${id}`)
  }

  updateWebServicePolicy(policy: any): Promise<any> {
    return AxiosService.put(this.soapPolicyEndpoint, policy)
  }

  copyWebServicePolicy(policy: any): Promise<any> {
    return AxiosService.put(`${this.soapPolicyEndpoint}/${policy.id}/${policy.configName}`)
  }

  generateCsv(config: any): Promise<any> {
    return AxiosService.get(`${this.soapPolicyEndpoint}/${config.id}/generate?totalLines=${config.totalLines}`, {
      responseType: 'blob',
    })
  }

  getTokenizerConfigsOfPolicy(id: number): Promise<any> {
    return AxiosService.get(`${this.soapPolicyEndpoint}/${id}/tokenizerconfigs`)
  }

  addTokenizerConfig(config: any): Promise<any> {
    return AxiosService.post(`${this.soapPolicyEndpoint}/${config.configId}/tokenizerconfigs`, config)
  }

  updateTokenizerConfig(config: any): Promise<any> {
    return AxiosService.put(this.soapTokenizerConfigEndpoint, config)
  }

  deleteTokenizerConfig(id: number): Promise<any> {
    return AxiosService.delete(`${this.soapTokenizerConfigEndpoint}/${id}`)
  }

  getAllSoapApps(): Promise<any> {
    return AxiosService.get(this.soapAppsEndpoint)
  }

  getSoapAppById(id: number): Promise<any> {
    return AxiosService.get(`${this.soapAppsEndpoint}/${id}`)
  }

  startWebServiceById(id: number): Promise<any> {
    return AxiosService.put(`${this.soapAppsEndpoint}/${id}/start`)
  }

  stopWebServiceById(id: number): Promise<any> {
    return AxiosService.put(`${this.soapAppsEndpoint}/${id}/stop`)
  }
}

export default new TestdataSoapRestService()
